export const mapVendorPriorityToOption = (priority) => ({
    id: priority.id,
    value: priority.id,
    text: priority.displayName,
    code: priority.code,
});

export const mapVendorPrioritiesToOptions = (priorities) => {
    if (!Array.isArray(priorities)) {
        return [];
    }
    return priorities.map(mapVendorPriorityToOption);
};

/**
 * Maps vendor list rows that already include embedded vendorPriorities from GET /vendor
 * (or incomplete vendors) into DataTable chip options.
 */
export const mapVendorsWithPriorities = (vendors) =>
    vendors.map((vendor) => ({
        ...vendor,
        vendorPriorities: mapVendorPrioritiesToOptions(vendor.vendorPriorities),
    }));

export const createPaymentPriorityColumn = ({ options, onRefresh, setNotification, api }) => ({
    accessor: 'vendorPriorities',
    Header: 'Payment Priority',
    editable: true,
    filterValues: (row) => (row.original.vendorPriorities || []).map((priority) => priority.text),
    editProps: {
        type: 'autocomplete-multiple-chips',
        options,
        modalHeader: 'Add payment priorities for this vendor',
        addButtonText: 'Add Priorities',
        addItem: async ({ row, values }) => {
            for (const value of values) {
                const res = await api.addVendorPriorityToVendor(row.id, value);
                if (!res.status) {
                    setNotification({ text: res.msg || 'Error adding payment priority', level: 'error' });
                    return false;
                }
            }
            setNotification({ text: 'Payment priorities updated!', level: 'success' });
            onRefresh();
            return true;
        },
        removeItem: async ({ item, row }) => {
            const priorityID = item.value ?? item.id;
            const res = await api.removeVendorPriorityFromVendor(row.id, priorityID);
            if (res.status === true) {
                setNotification({ text: 'Payment priority removed!', level: 'success' });
                onRefresh();
                return true;
            }
            setNotification({ text: res.msg || 'Error removing payment priority', level: 'error' });
            return false;
        },
    },
});
